import request from '@/utils/request';

export function getLanguageInfo(data) {
    return request({
        url: '/label/getLanguageInfo',
        method: 'post',
        data: data
    })
}
// AddList
// export function getLabelInfo(data) {
//     return request({
//         url: '/label/getLabelInfo',
//         method: 'post',
//         data: data
//     })
// }
export function getLabelList(data) {
    return request({
        url: '/label/getLabelList',
        method: 'post',
        data: data
    })
}
export function deleteLabel(data) {
    return request({
        url: '/label/deleteLabel',
        method: 'post',
        data: data
    })
}
export function saveLabel(data) {
    return request({
        url: '/label/saveLabel',
        method: 'post',
        data: data
    })
}
// AddOptions
// export function getPicklistInfo(data) {
//     return request({
//         url: '/picklist/getPicklistInfo',
//         method: 'post',
//         data: data
//     })
// }
export function getPicklistList(data) {
    return request({
        url: '/picklist/getPicklistList',
        method: 'post',
        data: data
    })
}
export function deletePicklist(data) {
    return request({
        url: '/picklist/deletePicklist',
        method: 'post',
        data: data
    })
}
export function saveOptions(data) {
    return request({
        url: '/picklist/save',
        method: 'post',
        data: data
    })
}
export function deletePicklistValue(data) {
    return request({
        url: '/picklist/deletePicklistValue',
        method: 'post',
        data: data
    })
}
export function getOptionList(data) {
    return request({
        url: '/picklist/getOptionList',
        method: 'post',
        data: data
    })
}